import styled from 'styled-components';

export const DefaultText = styled.p`
  color: #fff;
`;

export const DefaultTitle = styled.h2`
  color: #fff;
`;
